import { useState } from "react";
import { Container } from "react-bootstrap";
import Navbar from "./components/Navbar/navbar";
import Heder from "./components/heder/heder";
import Category from "./components/Category/category";
import CardList from "./components/CardList/cardList";

import MenuForm from "./pages/MenuForm";
import { Routes, Route, useLocation } from "react-router-dom"; // أضف useLocation
import Home from "./pages/Home";
import Slider from "./components/slider/slider";
import { CartProvider } from "./utils/CartContext";
import Cart from "./pages/cart";
import Offers from "./pages/offers";
import Footer from "./components/footer/footer";
import Auth from "./pages/auth";
import Admin from "./pages/Admin";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MyOrders from "./pages/MyOrders";
import AdminDashboard from "./pages/AdminDashboard";

function App() {
  const [category, setCategory] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
  const location = useLocation();  

  const handleSelectCategory = (selectedCat) => {
    setCategory(selectedCat);
  };

  return (
    <CartProvider>
      <div className="color-body font app-main-content">
        <Navbar onSearch={setSearchTerm} />
        <ToastContainer  className="handleMessages" position="top-right" />
        

        {/*  عرض السلايدر فقط في الصفحة الرئيسية */}
        {location.pathname === "/" && <Slider />}

        <Container>
          <Routes>
            <Route
              path="/menu"
              element={
                <>
                  <Heder />
                  <Category onSelectCategory={handleSelectCategory} />
                  <CardList category={category} searchTerm={searchTerm} />
                </>
              }
            />
            <Route path="/auth" element={<Auth/>} />
            <Route path="/Admin" element={<Admin/>} />
            <Route path="/my-orders" element={<MyOrders/>} />
            <Route path="/admin-dashboard" element={<AdminDashboard/>} />
            
            <Route path="/add" element={<MenuForm />} />
            <Route path="/" element={<Home />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="offers" element={<Offers/>}/>
          </Routes>
        </Container>
      </div>
      <Footer/>
    </CartProvider>
  );
}

export default App;
